import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { isApp } from "@/functions/enviroment";

import { HIGHLIGHT_COLOR } from "@/types/enum/propEnum";
import { HighlightBoxProps } from "@/types/props";


export default /*@__PURE__*/_defineComponent({
  __name: 'HighlightBox',
  props: {
    color: { default: HIGHLIGHT_COLOR.PURPLE },
    isReduced: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["highlight-box w-mc px-1 fw-600 light-light-color", [`highlight-bg-${__props.color}`, {'fs-13': _unref(isApp)(), 'fs-11': !_unref(isApp)()}, __props.isReduced ? 'reduced' : '']]),
    style: {"padding-top":"2px","padding-bottom":"2px","display":"inline-block"}
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})